import React from "react";
import { HelperError, Label } from "./ShortTextInput";

const BooleanInput = ({ id, name, label, value, onChange, error,required,helperText }) => {
  return (
    <div className="boolean-input">
      <Label id={id} required={required} label={label}  />
      <div className="radio-group mt-2">
        <label className="form-check-label">
          <input
            id={`${id}-true`}
            type="radio"
            name={name}
            value="true"
            checked={value === true}
            onChange={() => onChange({ target: { name, value: true } })}
            className="p4 form-check-input mt-0 me-2"
          />
          True
        </label>
        <label className="form-check-label">
          <input
            id={`${id}-false`}
            type="radio"
            name={name}
            value="false"
            checked={value === false}
            onChange={() => onChange({ target: { name, value: false } })}
            className="p4 form-check-input mt-0 me-2 ms-5"
          />
          False
        </label>
      </div>
      {(helperText || error) && <HelperError id={id} error={error} helperText={helperText}/>}
    </div>
  );
};

export default BooleanInput;
